// extracted by mini-css-extract-plugin
export var copy = "footer-newsletter-module--copy--6efc5";
export var formShell = "footer-newsletter-module--formShell--04c55";
export var heading = "footer-newsletter-module--heading--bf282";
export var wrapper = "footer-newsletter-module--wrapper--425b3";